export const useOgImage = () => {
  const config = useRuntimeConfig()

  const defaultOgImage =
    config.public.resourcesUrl + '/assets/front/images/og.jpg'

  return { defaultOgImage }
}
